import { ImageUrl } from "../utils/config/config";

/**
 * An uploaded image (a path under ImageUrl), or a placeholder when there is none or it fails to
 * load (#236, #237). Any other prop goes to the img: a class, alt text, a data-tag.
 *
 * @param {object} props
 * @param {string|null|undefined} props.image The stored file name.
 * @param {string} props.placeholder The public image shown instead, e.g. "/image/auction.png".
 */
export const FallbackImage = ({ image, placeholder, alt = "", ...rest }) => (
  <img
    {...rest}
    src={image ? `${ImageUrl}${image}` : placeholder}
    alt={alt}
    loading="lazy"
    onError={(event) => {
      if (!event.currentTarget.src.endsWith(placeholder)) event.currentTarget.src = placeholder;
    }}
  />
);

/** The placeholder the auction screens show for an auction without an image. */
export const AUCTION_PLACEHOLDER = "/image/auction.png";

/** The placeholder the lot screens show for a team without an image. */
export const TEAM_PLACEHOLDER = "/image/team-icon.png";
